import { PageSkeleton, SkeletonRegion } from "@ui";
import { useRouteLoading } from "./routeLoading";

interface RoutePreloaderProps {
  force?: boolean;
}

function RoutePreloader({ force = false }: RoutePreloaderProps) {
  const isLoading = useRouteLoading();

  if (!isLoading && !force) return null;

  return (
    <SkeletonRegion visible className="min-h-screen bg-surface-content">
      <PageSkeleton />
    </SkeletonRegion>
  );
}

export default RoutePreloader;
